document.addEventListener("DOMContentLoaded", function () {
  const splides = document.querySelectorAll(".mm-splide-v2-texte-image");
  if (splides) {
    splides.forEach(splideElem => {
      new Splide(splideElem, {
			type: "slide",
			arrows: true,
			pagination: true,
			perPage: 1,
			breakpoints: {
				768: {
					arrows: false,
				},
			},
		}).mount();

    });
  }
});
